import React from 'react'

import { MedicareDisplay } from '../components/MedicareDisplay'
import { useOnboarding } from '../OnboardingContext'
import { type StepComponentProps } from '../types'
import { MedicalPlansPage } from './MedicalPlansPage'
import { NoPlansAvailableRouter } from './NoPlansAvailableRouter'
import { OffThatchMedicalRouter } from './OffThatchMedicalRouter'

export function MedicalPlansPageRouter (props: StepComponentProps) {
  const { onboardingData } = useOnboarding()

  const existingEnrollments = onboardingData?.enrollments || []
  const defaultToByop = existingEnrollments.some(e => e.covers_medical && e.payment_method !== 'paid_by_thatch')
  const [viewingOffThatch, setViewingOffThatch] = React.useState(defaultToByop)

  if (!onboardingData) {
    return <div />
  }

  if (onboardingData.restrictions?.medicare_eligible) {
    return <MedicareDisplay {...props} />
  }

  if (onboardingData.restrictions?.additional_instructions_state) {
    return <NoPlansAvailableRouter {...props} existingPlan={defaultToByop} />
  }

  if (viewingOffThatch) {
    return <OffThatchMedicalRouter {...props} existingPlan={defaultToByop} setViewingOffThatch={setViewingOffThatch} />
  }

  return <MedicalPlansPage {...props} setViewingOffThatch={setViewingOffThatch} />
}
